import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from "web-vitals";

function send(metric: Metric) {
  const body = {
    name: metric.name,
    value: metric.value,
    rating: metric.rating,
    id: metric.id,
    navigationType: metric.navigationType,
  };

  if (import.meta.env.DEV) {
    console.info(`[web-vitals] ${body.name}`, body.value.toFixed(2), body.rating);
  }

  if (typeof window !== "undefined" && "gtag" in window) {
    const gtag = (window as unknown as { gtag?: (...args: unknown[]) => void }).gtag;
    gtag?.("event", metric.name, {
      value: Math.round(metric.name === "CLS" ? metric.value * 1000 : metric.value),
      metric_id: metric.id,
      metric_rating: metric.rating,
      metric_delta: metric.delta,
    });
  }
}

/** Register Core Web Vitals observers (CLS, INP, LCP, FCP, TTFB). */
export function reportWebVitals(): void {
  try {
    onCLS(send);
    onINP(send);
    onLCP(send);
    onFCP(send);
    onTTFB(send);
  } catch {
    // Older browsers without PerformanceObserver
  }
}
